import { PipeDataType } from "../../interface/dataTypeInterface";
// data from http://www.sweflow.se/images/pdf/Sveflow_hel.pdf

export const pipeData: PipeDataType[] = [
  {
    id: "SMS3008",
    name: "SMS 3008",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: "18.0" },
        dy: { value: 18, unit: "mm" },
        t: { value: 1, unit: "mm" },
      },
      {
        nominal_size: { value: "25.0" },
        dy: { value: 25, unit: "mm" },
        t: { value: 1.2, unit: "mm" },
      },
      {
        nominal_size: { value: "32.0" },
        dy: { value: 32, unit: "mm" },
        t: { value: 1.2, unit: "mm" },
      },
      {
        nominal_size: { value: "38.0" },
        dy: { value: 38, unit: "mm" },
        t: { value: 1.2, unit: "mm" },
      },
      {
        nominal_size: { value: "51.0" },
        dy: { value: 51, unit: "mm" },
        t: { value: 1.2, unit: "mm" },
      },
      {
        nominal_size: { value: "63.5" },
        dy: { value: 63.5, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "76.1" },
        dy: { value: 76.1, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "101.6" },
        dy: { value: 101.6, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
    ],
  },
  {
    id: "DIN11850",
    name: "DIN 11850",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: "DN10" },
        dy: { value: 13, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN15" },
        dy: { value: 19, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN20" },
        dy: { value: 23, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN25" },
        dy: { value: 29, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN32" },
        dy: { value: 35, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN40" },
        dy: { value: 41, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN50" },
        dy: { value: 53, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN65" },
        dy: { value: 70, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN80" },
        dy: { value: 85, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN100" },
        dy: { value: 104, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN125" },
        dy: { value: 129, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN150" },
        dy: { value: 154, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
    ],
  },
  {
    id: "DIN11866DIN",
    name: "DIN 11866 - DIN",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: "DN6" },
        dy: { value: 8, unit: "mm" },
        t: { value: 1, unit: "mm" },
      },
      {
        nominal_size: { value: "DN8" },
        dy: { value: 10, unit: "mm" },
        t: { value: 1, unit: "mm" },
      },
      {
        nominal_size: { value: "DN10" },
        dy: { value: 13, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN15" },
        dy: { value: 19, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN20" },
        dy: { value: 23, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN25" },
        dy: { value: 29, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN32" },
        dy: { value: 35, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN40" },
        dy: { value: 41, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN50" },
        dy: { value: 53, unit: "mm" },
        t: { value: 1.5, unit: "mm" },
      },
      {
        nominal_size: { value: "DN65" },
        dy: { value: 70, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN80" },
        dy: { value: 85, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN100" },
        dy: { value: 104, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN125" },
        dy: { value: 129, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN150" },
        dy: { value: 154, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN200" },
        dy: { value: 204, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
    ],
  },
  {
    id: "DIN11866ISO",
    name: "DIN 11866 - ISO",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: "DN8" },
        dy: { value: 13.5, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN10" },
        dy: { value: 17.2, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN15" },
        dy: { value: 21.3, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN20" },
        dy: { value: 26.9, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN25" },
        dy: { value: 33.7, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN32" },
        dy: { value: 42.4, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN40" },
        dy: { value: 48.3, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN50" },
        dy: { value: 60.3, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN65" },
        dy: { value: 76.1, unit: "mm" },
        t: { value: 2.0, unit: "mm" },
      },
      {
        nominal_size: { value: "DN80" },
        dy: { value: 88.9, unit: "mm" },
        t: { value: 2.3, unit: "mm" },
      },
      {
        nominal_size: { value: "DN100" },
        dy: { value: 114.3, unit: "mm" },
        t: { value: 2.3, unit: "mm" },
      },
      {
        nominal_size: { value: "DN125" },
        dy: { value: 139.7, unit: "mm" },
        t: { value: 2.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN150" },
        dy: { value: 168.3, unit: "mm" },
        t: { value: 2.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN200" },
        dy: { value: 219.1, unit: "mm" },
        t: { value: 2.6, unit: "mm" },
      },
    ],
  },
  {
    id: "ASMEBPE",
    name: "ASME BPE",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: '1/2"' },
        dy: { value: 12.7, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '3/4"' },
        dy: { value: 19.05, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '1"' },
        dy: { value: 25.4, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '1 1/2"' },
        dy: { value: 38.1, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '2"' },
        dy: { value: 50.8, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '2 1/2"' },
        dy: { value: 63.5, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '3"' },
        dy: { value: 76.2, unit: "mm" },
        t: { value: 1.65, unit: "mm" },
      },
      {
        nominal_size: { value: '4"' },
        dy: { value: 101.6, unit: "mm" },
        t: { value: 2.11, unit: "mm" },
      },
    ],
  },
  {
    id: "ISO1127",
    name: "ISO 1127",
    updatedAt: "2022-07-26",
    data: [
      {
        nominal_size: { value: "DN10" },
        dy: { value: 17.2, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN15" },
        dy: { value: 21.3, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN20" },
        dy: { value: 26.9, unit: "mm" },
        t: { value: 1.6, unit: "mm" },
      },
      {
        nominal_size: { value: "DN20" },
        dy: { value: 26.9, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN25" },
        dy: { value: 33.7, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN32" },
        dy: { value: 42.4, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN40" },
        dy: { value: 48.3, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN50" },
        dy: { value: 60.3, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN65" },
        dy: { value: 76.1, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN80" },
        dy: { value: 88.9, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
      {
        nominal_size: { value: "DN100" },
        dy: { value: 114.3, unit: "mm" },
        t: { value: 2, unit: "mm" },
      },
    ],
  },
];
